<i18n src="@/lang/actions.json"></i18n>

<template>
  <el-main>
    <div>
      TYT REGISTER
    </div>
  </el-main>
</template>

<script>
export default {
  name: "user_register"
};
</script>

<style scoped></style>
